<template>
    <div :class="open ? classHelp + ' openHelp' :  classHelp + ' closeHelp'">
       
        <div style="float:right">
             	<s-button theme="" label="" icon="times-circle" @onclick="$emit('close')"/>
        </div>
        <div class="titleHelp">
           <s-l :id="'infoTitle'+id"> {{title}}</s-l>
        </div>
        <div class="containHelp">
        <s-l :id="'info_'+id"><slot></slot></s-l>
        </div>
    </div>
</template>
<style scoped>
.containHelp {
    overflow-y: auto;
    height: 400px;
    width: 100%;
}
.titleHelp {
    font-weight: bolder;
}
@keyframes openPlus {
    0% {
        transform: scale(0) rotate(360deg);
    }
    60% {
        transform: scale(0.8) rotate(-10deg);
    }
    100% {
        transform: scale(1) rotate(0deg);
    }
}
 .closeHelp {
   visibility: hidden;
 }        
 .openHelp {
      -webkit-animation: openPlus 1s ease forwards; /*trigger the keyframe*/
      visibility: visible;
      z-index: 200;
      opacity: 1;
  }
  .help {
        font-size: 20px;
        position: absolute;
        top: 20%;
        left: 5%;
        border-radius: 20px;
        border: thin silver solid ;
        padding : 15px;
        background-color: rgb(250, 250, 249);
        color: black;
        text-overflow: clip;
        width: 350px;
        height: 350px;
        display: table-cell;
        vertical-align: middle;
        text-align: justify;
        box-shadow: 10px 5px 5px gray;
        z-index: 10;
    }
     .helpBig {
        font-size: 20px;
        position: fixed;
        top: 20%;
        left: 5%;
        border-radius: 20px;
        border: thin silver solid ;
        padding : 15px;
        background-color: rgb(250, 250, 249);
        color: black;
        text-overflow: clip;
        width: 350px;
        height: 500px;
        display: table-cell;
        vertical-align: middle;
        text-align: justify;
        box-shadow: 10px 5px 5px gray;
        z-index: 10;
        margin: 0px;
    }
</style>
<script>
export default {
    props: ['open', 'title', 'id', 'big'],
    computed: {
        classHelp: {
            get() {
                if (typeof(this.big)=="undefined")
                    return 'help'
                else 
                    return this.big ? 'helpBig' : 'help';
            }
        }
    }
}
</script>